export default {
  Albania: 'Albania',
  Algeria: 'Algeria',
  Andorra: 'Andorra',
  Angola: 'Angola',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahrain: 'Bahrain',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Benin: 'Benin',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  Brazil: 'Brazil',
  'British Virgin Islands': 'British Virgin Islands',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cameroon: 'Cameroon',
  'Cape Verde': 'Cape Verde',
  'Central African Republic': 'Central African Republic',
  Congo: 'Congo',
  'Costa Rica': 'Costa Rica',
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  Denmark: 'Denmark',
  'Dominican Republic': 'Dominican Republic',
  Egypt: 'Egypt',
  Estonia: 'Estonia',
  'Faroe Islands': 'Faroe Islands',
  Finland: 'Finland',
  France: 'France',
  'French Guiana': 'French Guiana',
  'French Polynesia': 'French Polynesia',
  Gabon: 'Gabon',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Gibraltar: 'Gibraltar',
  Greece: 'Greece',
  Greenland: 'Greenland',
  Guadeloupe: 'Guadeloupe',
  Guatemala: 'Guatemala',
  Guernsey: 'Guernsey',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  Iran: 'Iran',
  Iraq: 'Iraq',
  Ireland: 'Ireland',
  'Isle of Man': 'Isle of Man',
  Israel: 'Israel',
  Italy: 'Italy',
  'Ivory Coast': 'Ivory Coast',
  Jersey: 'Jersey',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kosovo: 'Kosovo',
  Kuwait: 'Kuwait',
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  'North Macedonia': 'North Macedonia',
  Madagascar: 'Madagascar',
  Mali: 'Mali',
  Malta: 'Malta',
  Martinique: 'Martinique',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Montenegro: 'Montenegro',
  Mozambique: 'Mozambique',
  Netherlands: 'Netherlands',
  'New Caledonia': 'New Caledonia',
  Norway: 'Norway',
  Pakistan: 'Pakistan',
  'Palestine, State of': 'Palestine, State of',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Qatar: 'Qatar',
  Réunion: 'Réunion',
  Romania: 'Romania',
  'Saint Lucia': 'Saint Lucia',
  'Saint-Pierre and Miquelon': 'Saint-Pierre and Miquelon',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Spain: 'Spain',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  'Timor-Leste': 'Timor-Leste',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  'United Kingdom': 'United Kingdom',
  'Vatican City State/the Holy See': 'Vatican City State/the Holy See',
  'Wallis and Futuna': 'Wallis and Futuna',
};
